import { Accordion, AccordionContent, AccordionTrigger, AccordionItem } from "@/components/ui/accordion";

// Accessible accordion — type="single" + collapsible → only one item open at a time.
export default function FAQAccordion({ items }) {
  return (
    <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
      {items.map((item, i) => (
        <AccordionItem key={i} value={`faq-${i + 1}`} className="border-line">
          <AccordionTrigger
            data-testid={`faq-question-${i + 1}`}
            className="py-6 text-left font-display text-lg font-medium text-fg hover:no-underline hover:text-white [&[data-state=open]]:text-brand-light"
          >
            {item.q}
          </AccordionTrigger>
          <AccordionContent
            data-testid={`faq-answer-${i + 1}`}
            className="pb-6 text-base leading-relaxed text-fg-muted"
          >
            {item.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
